exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".memo-warning[data-v-5f076a53]{color:#8b0000;font-weight:700}", ""]);

// exports
